import type { MentionReference } from "@/lib/mentions/types";

export type LaunchContextCategory = "document" | "insight" | "experiment";

/** Maximum launch-context picks per category on project home. */
export const LAUNCH_CONTEXT_LIMIT_PER_CATEGORY = 5;

export type LaunchContextSelection = MentionReference[];
